import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import * as R from 'ramda'
import { CardTable } from 'components/shared/CardTable/CardTable'
import { CardTableHeader } from 'components/shared/CardTable/CardTableHeader'
import { CardTableHeaderCell } from 'components/shared/CardTable/CardTableHeaderCell'
import { CardTableRow } from 'components/shared/CardTable/CardTableRow'
import { CardTableCell } from 'components/shared/CardTable/CardTableCell'
import { CardTableNoResults } from 'components/shared/CardTable/CardTableNoResults'
import { useCardTableState } from 'components/shared/CardTable/useCardTableState'
import { Icon, SearchIcon } from 'components/shared/Icon/Icon'

import { Input } from 'components/shared/FormFields/common/Input/Input'

import { fetchDepartment } from 'api/departments'

import styles from './Access.module.scss'

import { MEMBERS_FIELD } from './model'

export const Access = ({ control, setValue }) => {
  const [search, setSearch] = React.useState('')
  const [rawData, setRawData] = React.useState([])
  const [isSearchFocused, setIsSearchFocused] = React.useState(false)

  const departmentId = control._formValues?.department?.value

  React.useEffect(async () => {
    if (departmentId) {
      const { response } = await fetchDepartment({ id: departmentId })

      if (response) {
        setRawData(
          response.users.map(user => ({
            id: user.id,
            name: user.first_name
              ? `${user.first_name} ${user.last_name}`
              : ' - ',
          })),
        )
      }
    }
  }, [departmentId])

  const selected = control._formValues[MEMBERS_FIELD]

  const {
    state: { allRowsSelected, displayedData },
    handlers: { toggleRowSelection, toggleSelectAll, deleteRow },
  } = useCardTableState({
    data: rawData,
    selected,
    rowId: 'id',
    searchByKeys: ['name'],
    searchBy: search,
    onValueChange: newValue =>
      setValue(MEMBERS_FIELD, newValue, { shouldValidate: true }),
  })

  if (R.isNil(departmentId)) {
    return (
      <Box className={styles.access} direction="column">
        <div className={styles.noDepartmentMessage}>
          {t`Select department in Details tab to manage user access within chosen department`}
        </div>
      </Box>
    )
  }

  return (
    <Box className={styles.access} direction="column">
      <div
        className={styles.hint}
      >{t`Select users with access to this job`}</div>
      <div className={styles.searchIcon}>
        {isSearchFocused || search ? null : (
          <Icon icon={SearchIcon} size={26} />
        )}
        <Input
          fieldClassName={styles.searchInput}
          name={MEMBERS_FIELD}
          onChange={e => setSearch(e.target.value)}
          value={search}
          onFocus={() => setIsSearchFocused(true)}
          onBlur={() => setIsSearchFocused(false)}
        />
      </div>

      <CardTable bodyClassName={styles.table}>
        <CardTableHeader
          withCheckbox
          toggleSelectAll={toggleSelectAll}
          selected={allRowsSelected}
        >
          <CardTableHeaderCell id={'name'} width="100%">
            {t`Members of the department`}
          </CardTableHeaderCell>
        </CardTableHeader>
        {displayedData.length ? (
          displayedData.map(({ name, id }) => {
            return (
              <CardTableRow
                key={id}
                id={id}
                withCheckbox
                selected={selected.includes(id)}
                toggleRowSelection={toggleRowSelection}
                deleteRow={deleteRow}
              >
                <CardTableCell width="100%">{name}</CardTableCell>
              </CardTableRow>
            )
          })
        ) : (
          <CardTableNoResults
            label={
              search ? t`No results found` : t`No members in this department`
            }
          />
        )}
      </CardTable>
    </Box>
  )
}
